import React from 'react';
import { ADAWidgitRoles } from '../../../models/ADA';
import './Arrow.scss';


const Arrow = ({ direction, darkMode, width, handleClick, hideFromADA, altText }) => {
    return (
        <div role={ADAWidgitRoles.Button} tabIndex={hideFromADA ? -1 : 0} aria-label={altText}className={`arrow ${direction} ${darkMode ? 'dark-mode' : ''}`} style={{ padding: width ? width : '3px' }} onClick={handleClick}></div>
    );
}

export default Arrow;